export default __webpack_public_path__ + "static/media/ari_kapelyan.b01e6fd7.jpg";